export default {
	"AdditionalPageTypes": true,
	"Admin": true,
	"Advertising": false,
	"AggregatedContentFeed": false,
	"AllowCustomFields": false,
	"AppConfig": false,
	"AppEcommerceManager": false,
	"AppScorePredictor": false,
	"AppSocialManager": false,
	"AppTicketingManager": false,
	"BreakingNews": false,
	"BuildManager": true,
	"Calendar": false,
	"CustomCommentary": false,
	"CustomLineups": false,
	"CustomTables": false,
	"CustomTags": false,
	"Dashboard": true,
	"Fixtures": false,
	"Forms": true,
	"HomepageManager": true,
	"HomepageNewsPromo": false,
	"HomepagePlayerHighlight": false,
	"Lab": false,
	"MatchdayTakeover": false,
	"Media": true,
	"News": false,
	"OptaIntegration": false,
	"Organisations": false,
	"OverlayPromos": false,
	"Pages": true,
	"PagesAltTitles": true,
	"PlatformOptions": true,
	"PlayerVoting": false,
	"PreventEntitlementEmails": false,
	"Profile": true,
	"RelatedContentTagging": false,
	"RewardsManager": false,
	"RewardPoints": false,
	"Rover": false,
	"Settings": false,
	"SiteConfig": true,
	"Sponsors": false,
	"Squads": false,
	"SsoUsers": false,
	"StreamAMGIntegration": false,
	"Streamline": false,
	"StreamlineAdverts": false,
	"StreamlinePromoCodes": false,
	"TeamCrestManager": false,
	"Videos": false,
	"Voice": false,
	"WebStats": true
}
